const isEmail = (value: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (emailRegex.test(value)) {
        return true
    } else {
        return false
    }

}

const isPhoneNumber = (value: string): boolean => {
    const cleaned = value.replace(/[\s,-]/g, "");
    // Sprawdza czy zostało dokładnie 9 cyfr
    return /^\d{9}$/.test(cleaned);
}

const FormHelper = {
    isEmail,
    isPhoneNumber,
}

export default FormHelper